import { get } from '../Services/http';
import { catchError } from './Error.action';

import {
  DELIVERYDATES_SET,
  DELIVERYDATES_LOADER,
  CHECKOUT_SUBMIT_ERROR,
} from '../constants';

export const getDeliveryDate = () => (dispatch, getState) => {
  dispatch(setLoading(true));
  get('/api/deliveryDates/getDeliveryDates')
    .then((response) => response.json())
    .then((result) => {
      dispatch({
        type: DELIVERYDATES_SET,
        payload: {
          datesArray: result,
        },
      });
    })
    .catch((ex) => {
      console.error(ex.message);
      dispatch(catchError(ex, (error) => submitError(error)));
    })
    .finally(() => {
      dispatch(setLoading(false));
    });
};

export const setLoading = (loading) => ({
  type: DELIVERYDATES_LOADER,
  payload: {
    loading,
  },
});

export const submitError = (error) => ({
  type: CHECKOUT_SUBMIT_ERROR,
  payload: {
    error,
  },
});
